export const BACKEND_HOST_URL = "https://blog-website-mern-navy.vercel.app"
export const GOOGLE_CLIENT_ID = "422813784314-0ufataavfm44p5usepp07rr6ng84n97l.apps.googleusercontent.com"
export const GOOGLE_CLIENT_SECRET = "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"
export const CLOUDINARY_USER_NAME = "dquxwox28"